import { render, staticRenderFns } from "./CreateProgram.vue?vue&type=template&id=74468f2e&scoped=true"
import script from "./CreateProgram.vue?vue&type=script&lang=js"
export * from "./CreateProgram.vue?vue&type=script&lang=js"
import style0 from "./CreateProgram.vue?vue&type=style&index=0&id=74468f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74468f2e",
  null
  
)

export default component.exports